import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { afterItems, beforeItems } from "../../data/content";
export function BeforeAfterSection() {
  return <section className="bg-sand px-4 py-16 sm:px-5 sm:py-24" aria-label="Before and after" data-id="element-90" data-mp="3ahk5zrqa9uxp">
      <div className="mx-auto max-w-5xl" data-id="element-91" data-mp="3fgmx089fi0mo">
        <SectionHeading title="What You'll Be Able to Organize After Using the System" data-id="element-92" data-mp="6y7bo1jlcnr3" />

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-93" data-mp="bxk73aoj335a">
          <div className="rounded-3xl bg-white p-6 sm:p-8 ring-2 ring-alert/25" data-id="element-94" data-mp="bx20bk48p6j4">
            <div className="flex items-center gap-3" data-id="element-95" data-mp="3tdjuutnysid2">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-alert text-white" data-id="element-96" data-mp="27qymijon459">
                <XIcon className="h-6 w-6" aria-hidden="true" data-id="element-97" data-mp="px32d2w8qk06" />
              </span>
              <h3 className="font-serif text-3xl font-bold text-alert" data-id="element-98" data-mp="uo1lsbcizy7n">Before</h3>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-99" data-mp="22nurtwdgmcnx">
              {beforeItems.map(item => <li key={item} className="flex gap-3 text-base sm:text-[17px] leading-relaxed text-ink/80" data-id="element-100" data-mp="1xp1d60mfsfm6">
                  <XIcon className="mt-1 h-5 w-5 shrink-0 text-alert" aria-hidden="true" data-id="element-101" data-mp="2cdnqxxwf0zba" />
                  <span data-id="element-102" data-mp="27n7eoh4bzjqi">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl bg-navy p-6 sm:p-8 ring-2 ring-cta" data-id="element-103" data-mp="2lec4yslt6zo6">
            <div className="flex items-center gap-3" data-id="element-104" data-mp="2lgovhu5muicu">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta text-white" data-id="element-105" data-mp="2gehf8sdrsg4p">
                <CheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-106" data-mp="2vbgun2ev5d9q" />
              </span>
              <div data-id="element-107" data-mp="2qeqfchavulpd">
                <h3 className="font-serif text-3xl font-bold text-white" data-id="element-108" data-mp="2qe8awxe2h16d">After</h3>
                <p className="text-xs font-bold uppercase tracking-wider text-gold" data-id="element-109" data-mp="10zsa8kpv4ihy">With Otoplasty Clinical Pathway System™</p>
              </div>
            </div>
            <ul className="mt-6 space-y-4" data-id="element-110" data-mp="1lo2zngw1vdbq">
              {afterItems.map(item => <li key={item} className="flex gap-3 text-base sm:text-[17px] leading-relaxed text-white" data-id="element-111" data-mp="1ppesrwe4ugoo">
                  <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-112" data-mp="1uoreuex6jjq7" />
                  <span data-id="element-113" data-mp="1znkvgg7rjqul">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-2 text-center text-lg text-ink/80" data-id="element-114" data-mp="24n76qk416x0r">
          <p data-id="element-115" data-mp="28o0w7hx4gjvr">The goal isn't to give you more information for the sake of it.</p>
          <p className="font-semibold text-ink" data-id="element-116" data-mp="28lwk4cp2keke">It's to help you organize and get more value from the information you already study.</p>
        </div>

        <div className="mt-10" data-id="element-117" data-mp="2id0yba6x7ve6">
          <CtaButton label="I want to study otoplasty with a system" data-id="element-118" data-mp="2ig6kagk96h5o" />
        </div>
      </div>
    </section>;
}